<!--

    Copyright (c) 2017-present, Siklu Ltd.
    All rights reserved.

-->
<div class="stretch-to-parent">
    <div class="customers-main-box">
        <div class="customers-header p-3">
            <div class="title">
                <h2>
                    <span class="companies-header"> {{ 'customer.home.title' | translate }} </span>
                </h2>
                <ng-container *ngIf="isCustomerPage() && !showOnlyCompanyNameInHeader()">
                    <winde-ctx-sensitive-help placement="right" tooltipTextPath="customer.btn.create">
                        <button
                                [routerLink]="[{ outlets: { popup: [action.CREATE, 'customer'] } }]"
                                queryParamsHandling="preserve"
                                windeActionIcon
                        >
                            <sui-svg-icon class="add-customer-button" icon="plus-circle" windeGreen/>
                        </button>
                    </winde-ctx-sensitive-help>
                </ng-container>
            </div>

            <ng-container *ngIf="isCustomerPage() && !showOnlyCompanyNameInHeader()">
                <div *windeHasAnyAuthority="[userAuthorities.SIKLU_ADMIN, userAuthorities.SIKLU_ACCOUNTANT]" class="pl-2 header-btns-row">
                    <div>
                        <button
                                [routerLink]="[{ outlets: { popup: ['locations'] } }]"
                                class="btn-link btn-sm btn--company-locations"
                                queryParamsHandling="preserve"
                                windeTransparent
                        >
                            <sui-svg-icon icon="globe" windeGrey/>
                            <span>{{ 'customer.home.companyLocations.title' | translate }}</span>
                        </button>
                    </div>
                    <div>
                        <button
                                [routerLink]="['', { outlets: { popup: 'eula/update' } }]"
                                class="btn-link btn-sm btn--update-eula"
                                queryParamsHandling="preserve"
                                windeTransparent
                        >
                            <sui-svg-icon icon="file-text" windeGrey/>
                            <span>{{ 'eula.title.update' | translate }}</span>
                        </button>
                    </div>
                    <div>
                        <button
                                [routerLink]="['', { outlets: { popup: 'customer-restrictions' } }]"
                                class="btn-link btn-sm btn--update-eula"
                                queryParamsHandling="preserve"
                                windeTransparent
                        >
                            <sui-svg-icon icon="file-text" windeGrey/>
                            <span>{{ 'customer.home.customer-restrictions' | translate }}</span>
                        </button>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="isProjectsPage() && !showOnlyCompanyNameInHeader()">
                <div *windeHasAnyAuthority="[userAuthorities.SIKLU_ACCOUNTANT]" class="pl-2 header-btns-row">
                    <button
                            [routerLink]="['', { outlets: { popup: 'preferences/edit' } }]"
                            class="btn-link btn-sm btn--preferences"
                            queryParamsHandling="preserve"
                            windeTransparent
                    >
                        <sui-svg-icon icon="cog" windeGrey/>
                        <span>{{ 'preferences.title' | translate }}</span>
                    </button>
                </div>
            </ng-container>
        </div>
        <div class="customers-content">
            <form class="search-field">
                <div class="search-input">
                    <button windeActionIcon>
                        <sui-svg-icon icon="search" windeGrey/>
                    </button>
                    <input [(ngModel)]="searchFilter" [ngModelOptions]="{ standalone: true }"/>
                </div>
                <div [hidden]="!searchFilter()" class="clear-button">
                    <winde-ctx-sensitive-help placement="bottom" tooltipTextPath="customer.searchField.btn.clear">
                        <button [queryParams]="{ filter: '' }" [routerLink]="['./']" queryParamsHandling="merge" windeActionIcon>
                            <sui-svg-icon icon="cross" windeRed/>
                        </button>
                    </winde-ctx-sensitive-help>
                </div>
            </form>
            <ng-container *ngIf="customers$ | async as customers">
                <cdk-virtual-scroll-viewport
                        *ngIf="customers.length; else noCustomers"
                        [ngClass]="{ 'customers-page': isCustomerPage() && !showOnlyCompanyNameInHeader(), 'projects-page': isProjectsPage()}"
                        class="custom-scroll-bar custom-scroll-bar--light"
                        itemSize="48"
                >
                    <ul *ngIf="scrollToSelectedCustomer$ | async" class="list-group">
                        <li
                                *cdkVirtualFor="let customer of customers"
                                [ngClass]="{ 'list-group-item-active': (selectedCustomerId$ | async) === customer.id }"
                                [queryParams]="{ company_id: customer.id, page: 1 }"
                                [routerLink]="['./']"
                                class="d-flex flex-nowrap customer justify-content-between"
                                queryParamsHandling="merge"
                        >
                            <strong
                                    [disabled]="tooltipsAreDisabled"
                                    [showDelay]="tooltipShowDelay"
                                    [tooltipText]="customer.name"
                                    class="customer-name-label"
                                    position="top"
                                    suiTooltip
                            >
                                <winde-highlight-text [searchSubstring]="searchFilter()" [text]="customer.name"></winde-highlight-text>
                            </strong>
                            <div class="customer__badges-list">
                                <button *ngIf="customer.blocked" windeActionIcon>
                                    <sui-svg-icon icon="block" windeRed/>
                                </button>
                                <div *ngIf="customer.sikluCompany" class="customer__badge customer__badge--isSiklu"></div>
                                <div class="customer__badge customer__badge--numbers">
                                    <winde-ctx-sensitive-help [tooltipTextPath]="'customer.badge.' + badgeAttribute()" placement="left">
                                        <span class="badge badge-default badge-pill"> {{ customer[badgeAttribute()] }} </span>
                                    </winde-ctx-sensitive-help>
                                </div>
                            </div>
                        </li>
                    </ul>
                </cdk-virtual-scroll-viewport>
            </ng-container>
            <ng-template #noCustomers>
                <div class="text-center pt-4 d-block">{{ 'customer.home.customersNotFound' | translate }}</div>
            </ng-template>
        </div>
    </div>
</div>
